// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_AcceptanceRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_AcceptanceRow — one row of the acceptance audit listing.
 *
 * `termo_idioma` is the language VARIANT the signer read; `termo_versao` is
 * the version of the market's agreement. Both are recorded because they are
 * different facts: someone who read the Chilean Spanish translation of version
 * 2.0 agreed to version 2.0, and an auditor still needs to know which wording
 * was in front of them.
 *
 * Every termo_* field is the SNAPSHOT stored on the acceptance itself, not a
 * join onto `subscription_terms`: the document may have been edited,
 * deactivated or deleted since, and a join would empty the evidence exactly
 * when someone is looking for it.
 *
 * The signature IMAGE is absent here on purpose — a page of 200 acceptances
 * would otherwise carry megabytes of base64 that the table never renders. Its
 * hash and method are present, and the detail read carries the image.
 */
import { registerContract } from './validate'

export interface SubscriptionTerms_AcceptanceRow {
id: number
term_id?: number
franquia_id?: number
subscription_id?: number
franquia_nome?: string
termo_titulo?: string
termo_versao?: string
plan_id?: number
termo_plano?: string
termo_idioma?: string
term_variant_id?: number
content_sha256?: string
assinatura_sha256?: string
assinatura_metodo?: string
accepted_by_sub?: string
accepted_by_email?: string
ip_address?: string
created_at?: string
}

registerContract('SubscriptionTerms_AcceptanceRow', {
  id:                { type: 'number',  required: true },
  term_id:           { type: 'number',  required: false },
  franquia_id:       { type: 'number',  required: false },
  subscription_id:   { type: 'number',  required: false },
  franquia_nome:     { type: 'string',  required: false },
  termo_titulo:      { type: 'string',  required: false },
  termo_versao:      { type: 'string',  required: false },
  plan_id:           { type: 'number',  required: false },
  termo_plano:       { type: 'string',  required: false },
  termo_idioma:      { type: 'string',  required: false },
  term_variant_id:   { type: 'number',  required: false },
  content_sha256:    { type: 'string',  required: false },
  assinatura_sha256: { type: 'string',  required: false },
  assinatura_metodo: { type: 'string',  required: false },
  accepted_by_sub:   { type: 'string',  required: false },
  accepted_by_email: { type: 'string',  required: false },
  ip_address:        { type: 'string',  required: false },
  created_at:        { type: 'string',  required: false },
})
